import memoize from 'memoizee';
const pluck = (data, path) => {
    let internalData = {...data};
    try{
        if(!path){
            return data
        }
        
        const keys = path.split('.');
        for(let key of keys){
            if(typeof data !== "object" || typeof internalData[key] === 'undefined'){throw(false)}
            internalData = internalData[key];
        }
    
        return internalData 
    }catch(e){
        return null
    }
}

export default memoize(pluck);